var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "hover_0", staticStyle: { cursor: "pointer" } },
    [
      null != _vm.marked && _vm.marked
        ? _c("img", {
            attrs: {
              title: "你关注了这个工单,点击可取消关注",
              src:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABf0lEQVQ4T52TvS9DYRTGn6fte8VAze29NxGRXgMDkZBYpJFYDFb+AB+7ycRsFf0HJAaT2DTdfAxCScRtJMS9YWWSuG9vj7QNWuoq73qe8zvnPOe8RMRzLbUFgI6vF3+S8aeAayElUPckE/FQxvsf9EkrbQRA5UAu1JPk0PH0RNsA1zSGQCmC/CwQVrLOQ7nwFdKyA9dWeYDZRrFAzgc8PfwNcJOGWYmrSRFWq45AMAays7U38grBsQBnMeIiFuoCXdu4BdAbtY2I2B2vTWOOMWz/ByAVzNc8cC21CXL5TxDBhuMHKzWAAPGSZeyDmG4LIpJzfL1U1X5sQYBEyVJHIEcjISKXGV8PEwibAPVRjD0QM1EAgeQHPD31rmm6A9dSlyAHfxnj1vGCvtYAWz0DTEZ2IFJ2fG2wZl2DB3c96HntNp7ek0XkgJS1uFc+DW1VNWwdYFf9awRpx8djE+AG6AhtoyjAVUywm/GDncZOSibSQrUq5GyyHPSlHvFSjb8BT4GGUFv6c6YAAAAASUVORK5CYII="
            },
            on: { click: _vm._off }
          })
        : _vm._e(),
      _vm._v(" "),
      null != _vm.marked && !_vm.marked
        ? _c("img", {
            attrs: {
              title: "点击关注这个工单",
              src:
                "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABd0lEQVQ4T52Suy+DURjGnyeEaiLMGCpmBiIhsYhILAZLB/4Al73nNLF8bO/5pE2aCP+ARBqT2DQ2l0HcEiu1WJnaSquvfIIovhZnO3me9/deiTpPRDZI0hizEGZjmCAiXQDuSDar6qi19uQnbyjAObcJYP4t6NAYM/ZrgO/7A6p6AeAjAcmJRCJx8BXyYwUikgsCPptV9dxaO/gNICI9AMZJBlmHSI4AaAuZzROAY1U9I3mpqgd0zt0A6K23jTraLX3fn1XVrf8ASM69zkBE1kku/RGyZoxJvAKy2WxTPp/fAzD1G4iqblprFwPvxxY8z2uORqNHAIYbQK5isdhgPB5/rgEEH+fcLoDpBoCcMWby3VNzByJyRbK/HkBVb6y1fWGAR5IdDQAVY0wLSa1pIZ1Od5bL5Yf3YFXdJ7kSiUROi8ViMLBVku2Brqrd1tr7GkAmk2ktlUrB/V9Xq9WdZDK5/bmSVCrVXalUlgHMFAqFPs/zCoH+ArY6kT8+CaLVAAAAAElFTkSuQmCC"
            },
            on: { click: _vm._on }
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b4cf5c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b4cf5c8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketMark.vue
// module id = 728
// module chunks = 75